// removed by extract-text-webpack-plugin
module.exports = {"search":"search-results__search___1Epcp","container":"search-results__container___15Pwf","section-title":"search-results__section-title___1iME1","section-title-inner":"search-results__section-title-inner___3dqK-","list":"search-results__list___3027e"};


//////////////////
// WEBPACK FOOTER
// ./app/components/SearchResults/search-results.scss
// module id = 288
// module chunks = 0